import classNames from 'classnames';
import React, { FC } from 'react';
import { SpecialOffers } from 'store/landing/types';
import { useLandingPageContext } from 'context/LandingPageContext';
import { useTranslation } from 'react-i18next';
import styles from './SpecialOffer.module.scss';

const SpecialOffer: FC<SpecialOffers> = ({
  bannerImageUrlDesktop,
  button,
  descriptionLines,
  discount,
  name,
  title,
}) => {
  const { theme, isDesktopDevice, plusMembershipStatus } = useLandingPageContext();
  const { isPlusActive } = plusMembershipStatus;
  const { t } = useTranslation();

  const isActive = discount && discount.label && discount.voucherCode;

  return (
    <div className={styles.row}>
      <div className={classNames(styles.container, styles[`theme-${theme}`])}>
        <div className={styles.content}>
          {title && isDesktopDevice && <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />}
          {bannerImageUrlDesktop && (
            <a href={button.referenceUrl} className={styles.link}>
              <img alt={name} src={bannerImageUrlDesktop} className={styles.image} />
              {isActive && (
                <div
                  className={classNames(styles.discount__bubble, {
                    [styles.bubbleColorRegularDiscount]: !isPlusActive || isDesktopDevice,
                    [styles.bubbleColorPlusDiscount]: isPlusActive && !isDesktopDevice,
                  })}
                  style={{
                    backgroundColor: discount.bubbleBackgroundColor,
                    color: discount.fontColor,
                  }}
                >
                  {discount.label}
                </div>
              )}
            </a>
          )}
          {title && !isDesktopDevice && <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />}
          {isActive && (
            <div className={styles.discount}>
              <span className={styles.discountLabel}>{t('txt_code')}:</span>
              <span
                className={classNames(styles.discount__code, {
                  [styles.colorRegularDiscount]: !isPlusActive || isDesktopDevice,
                  [styles.colorPlusDiscount]: isPlusActive && !isDesktopDevice,
                })}
              >
                {discount.voucherCode}
              </span>
            </div>
          )}
          <div className={styles.description}>
            <ul>
              {descriptionLines &&
                descriptionLines.map(({ text }) => <li dangerouslySetInnerHTML={{ __html: text }} />)}
            </ul>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <div className={classNames(styles.button, styles[`theme-${button.style}`])}>
            <a className={styles.btn} href={button.referenceUrl}>
              {button.label}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialOffer;
